import { render, staticRenderFns } from "./cardShowAnnounceToDay.vue?vue&type=template&id=69ffb52d&scoped=true"
import script from "./cardShowAnnounceToDay.vue?vue&type=script&lang=js"
export * from "./cardShowAnnounceToDay.vue?vue&type=script&lang=js"
import style0 from "./cardShowAnnounceToDay.vue?vue&type=style&index=0&id=69ffb52d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ffb52d",
  null
  
)

export default component.exports